import type { LResult, LSplit } from '../../types';

function findSplit(result: LResult, checkpointId: number | nil): LSplit | null {
  return result?.splits?.find((split) => split.checkpoint_id === (checkpointId as any)) || null;
}

export { findSplit };
